import React, { useRef, Fragment, useCallback, forwardRef } from 'react';
import cx from 'classnames';
import Text, { TextSize } from '@move-ui/text';
import { CheckmarkIcon } from '@move-ui/icons-asset-catalog';
import { mergeRefs } from '@move-web-essentials-utils/ref';
import { Checkbox } from '@move-ui/checkbox';
import styles from './Option.module.css';
import { stopEvent } from '../utils/stopEvent';
export const Option = forwardRef(({ id, idPrefix, onClick, selected, label, sectionLabel, description, focusPrevious, focusNext, icon, multiple }, parentRef) => {
    const ref = useRef(null);
    const onKeyPress = useCallback((event) => {
        switch (event.key) {
            case 'Enter':
            case ' ':
                onClick();
                break;
            case 'ArrowUp':
                focusPrevious === null || focusPrevious === void 0 ? void 0 : focusPrevious();
                break;
            case 'ArrowDown':
                focusNext === null || focusNext === void 0 ? void 0 : focusNext();
                break;
            default:
                return;
        }
        stopEvent(event);
    }, [onClick, focusPrevious, focusNext]);
    return (React.createElement(Fragment, null,
        sectionLabel && (React.createElement("div", { className: styles.section, "data-testid": "Section" },
            React.createElement(Text, { size: TextSize.XXS, bold: true, color: "neutral-200" }, sectionLabel))),
        React.createElement("li", { className: cx(styles.option, { [styles.selected]: selected }), role: "option", "aria-selected": selected, onClick: onClick, onKeyPress: onKeyPress, onKeyDown: onKeyPress, tabIndex: -1, ref: mergeRefs(ref, parentRef) },
            multiple && (React.createElement(Checkbox, { id: id && `${idPrefix || ''}${id}`, className: styles.checkBox, name: `${label}`, checked: !!selected, onChange: () => null, tabIndex: -1 })),
            !multiple && selected && React.createElement(CheckmarkIcon, null),
            icon && (React.createElement("div", { className: styles.iconWrapper },
                React.createElement("div", { className: styles.icon, "data-testid": "OptionIcon" }, icon))),
            React.createElement(Text, { size: TextSize.M, bold: selected || multiple, color: "neutral-100" },
                label,
                description && (React.createElement(Text, { size: TextSize.XXS, color: "neutral-200" }, description))))));
});
//# sourceMappingURL=Option.js.map